export const SERVICE_NAME = '스낵 사주' as const
export const CONTACT_EMAIL = 'tto9208@gmail.com' as const
